
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5 4h22v2.344l-.219.281L19 16.344V23.5l-.406.313-4 3L13 28.001V16.345L5.219 6.626 5 6.345V4.001zm2.281 2l7.188 9h3.063l7.188-9H7.282zM15 17v7l2-1.5V17h-2z"}})])
          )
        }
      }
    